/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * ProVersion Platform API
 * RECORTE GERADO — nao editar. Produzido por front/scripts/normative-contract.mjs
 * a partir de contract/openapi.yaml, contendo apenas operacoes `x-maturity: normative`.
 *
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AttendanceRecord,
  BadRequestResponse,
  CreateAttendanceAdjustmentRequest,
  ForbiddenResponse,
  NotFoundResponse,
  UnauthorizedResponse,
  UnprocessableEntityResponse
} from '../model';

import { apiFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListOccurrenceAttendanceUrl = (occurrenceId: string,) => {




  return `/v1/occurrences/${occurrenceId}/attendance`
}

/**
 * Presenca e apurada pelo sistema a partir dos eventos de sala, nunca
 * declarada. O professor **le e nao altera**: nao existe operacao de
 * confirmacao nem de contestacao por ele, e a ausencia dessa operacao e a
 * propria regra.
 *
 * `computed` e `adjusted` sao campos separados de proposito: o valor
 * apurado nunca e sobrescrito, porque e ele que sustenta a folha meses
 * depois.
 * @summary Lista a presenca apurada de uma ocorrencia
 */
export const listOccurrenceAttendance = async (occurrenceId: string, options?: Parameters<typeof apiFetch>[1]): Promise<AttendanceRecord[]> => {

  return apiFetch<AttendanceRecord[]>(getListOccurrenceAttendanceUrl(occurrenceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOccurrenceAttendanceQueryKey = (occurrenceId: string,) => {
    return [
    `/v1/occurrences/${occurrenceId}/attendance`
    ] as const;
    }


export const getListOccurrenceAttendanceQueryOptions = <TData = Awaited<ReturnType<typeof listOccurrenceAttendance>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOccurrenceAttendance>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOccurrenceAttendanceQueryKey(occurrenceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOccurrenceAttendance>>> = ({ signal }) => listOccurrenceAttendance(occurrenceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: occurrenceId !== null && occurrenceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOccurrenceAttendance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOccurrenceAttendanceQueryResult = NonNullable<Awaited<ReturnType<typeof listOccurrenceAttendance>>>
export type ListOccurrenceAttendanceQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse


export function useListOccurrenceAttendance<TData = Awaited<ReturnType<typeof listOccurrenceAttendance>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOccurrenceAttendance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOccurrenceAttendance>>,
          TError,
          Awaited<ReturnType<typeof listOccurrenceAttendance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOccurrenceAttendance<TData = Awaited<ReturnType<typeof listOccurrenceAttendance>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOccurrenceAttendance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOccurrenceAttendance>>,
          TError,
          Awaited<ReturnType<typeof listOccurrenceAttendance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOccurrenceAttendance<TData = Awaited<ReturnType<typeof listOccurrenceAttendance>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOccurrenceAttendance>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista a presenca apurada de uma ocorrencia
 */

export function useListOccurrenceAttendance<TData = Awaited<ReturnType<typeof listOccurrenceAttendance>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOccurrenceAttendance>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOccurrenceAttendanceQueryOptions(occurrenceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateAttendanceAdjustmentUrl = (attendanceRecordId: string,) => {




  return `/v1/attendance-records/${attendanceRecordId}/adjustments`
}

/**
 * Exclusiva de Super Admin e sensivel: exige reautenticacao recente. O
 * ajuste fica **ao lado** do valor apurado, com autor, instante e
 * justificativa; o apurado permanece intacto. Justificativa vazia e
 * recusada com 422.
 * @summary Super Admin corrige uma presenca, com justificativa
 */
export const createAttendanceAdjustment = async (attendanceRecordId: string,
    createAttendanceAdjustmentRequest: CreateAttendanceAdjustmentRequest, options?: Parameters<typeof apiFetch>[1]): Promise<AttendanceRecord> => {

  return apiFetch<AttendanceRecord>(getCreateAttendanceAdjustmentUrl(attendanceRecordId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAttendanceAdjustmentRequest)
  }
);}





export const getCreateAttendanceAdjustmentMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAttendanceAdjustment>>, TError,{attendanceRecordId: string;data: CreateAttendanceAdjustmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAttendanceAdjustment>>, TError,{attendanceRecordId: string;data: CreateAttendanceAdjustmentRequest}, TContext> => {

const mutationKey = ['createAttendanceAdjustment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAttendanceAdjustment>>, {attendanceRecordId: string;data: CreateAttendanceAdjustmentRequest}> = (props) => {
          const {attendanceRecordId,data} = props ?? {};

          return  createAttendanceAdjustment(attendanceRecordId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAttendanceAdjustmentMutationResult = NonNullable<Awaited<ReturnType<typeof createAttendanceAdjustment>>>
    export type CreateAttendanceAdjustmentMutationBody = CreateAttendanceAdjustmentRequest
    export type CreateAttendanceAdjustmentMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse

    /**
 * @summary Super Admin corrige uma presenca, com justificativa
 */
export const useCreateAttendanceAdjustment = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAttendanceAdjustment>>, TError,{attendanceRecordId: string;data: CreateAttendanceAdjustmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAttendanceAdjustment>>,
        TError,
        {attendanceRecordId: string;data: CreateAttendanceAdjustmentRequest},
        TContext
      > => {
      return useMutation(getCreateAttendanceAdjustmentMutationOptions(options), queryClient);
    }
